import { crudRequest } from '@/services/api';

export default {
  namespace: 'realTimeBroadcast',
  state: {
    menuKey: '1',
  },
  effects: {
    *getSearchTimeTitle(_, { put }) {
      // 获取筛选时间标题文字
      yield put({
        type: 'update',
        payload: {
          filter: { ...paramsForm },
        },
      });
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
